import React, { useState, useRef, useCallback, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  SmoothStepEdge,
  useNodesState,
  useEdgesState,
  Controls,
  Background,
  BackgroundVariant,
  MarkerType,
} from "reactflow";
import "reactflow/dist/style.css";
import Sidebar from "./Sidebar";
import "./Flow.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/templateBuilder.css";
import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";

import search1 from "../../assets/icons/search1.svg";
import close from "../../assets/icons/close.svg";
import folder from "../../assets/icons/folder.svg";

import ImageNode from "./ImageNode";
import DefaultNode from "./DefaultNode";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
const nodeTypes = {
  imageNode: ImageNode, // Register your custom node type
  // default: DefaultNode,
  defaultNode: DefaultNode,
};

const DnDFlow = () => {
  const [loading, setLoading] = useState(false);
  const reactFlowWrapper = useRef(null);
  const [master, setMaster] = useState([]);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null); // Track selected node
  const [editData, setEditData] = useState({}); // Track data to be edited
  const [contextMenu, setContextMenu] = useState({
    isOpen: false,
    position: { x: 0, y: 0 },
  });
  const [usedNodes, setUsedNodes] = useState([]); // State to track used nodes
  const [edgeToDelete, setEdgeToDelete] = useState(null); // Track edge to delete
  const [edgeLabelModal, setEdgeLabelModal] = useState({
    isOpen: false,
    label: "",
    edgeId: null,
  }); // New state for edge label modal
  const templateNameRef = useRef(null);
  const templateCodeRef = useRef(null);
  const [templateName, setTemplateName] = useState("");
  const [templateCode, setTemplateCode] = useState("");

  const { template_type_id } = useParams();
  const navigate = useNavigate();
  const [TemplateTypeName, setTemplateTypeName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const fetchNodes = async () => {
    setLoading(true);
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-type-master/${template_type_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      setMaster(data);
      setTemplateTypeName(data.templateType.template_type_name);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching nodes:", error);
      setLoading(false);
      // Handle unauthorized error
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
      } else {
        // Handle other errors as needed
        console.error(error);
      }
    }
  };

  // useEffect(() => {
  //   const firstNodeId = nodes.length > 0 ? nodes[0].id : null;

  //   if (firstNodeId) {
  //     setNodes((nds) =>
  //       nds.map((node) =>
  //         node.id === firstNodeId
  //           ? {
  //               ...node,
  //               style: {
  //                 backgroundColor: "blue !important",
  //                 color: "red",
  //               },
  //             }
  //           : node
  //       )
  //     );
  //   }
  // }, [nodes, setNodes]);
  useEffect(() => {
    const firstNodeId = nodes.length > 0 ? nodes[0].id : null;

    if (firstNodeId) {
      setNodes((nds) =>
        nds.map((node) =>
          node.id === firstNodeId
            ? {
                ...node,
                className: "first-node-highlight", // Apply custom class
              }
            : node
        )
      );
    }
  }, [nodes, setNodes]);
  const onConnect = useCallback(
    (params) => {
      const { source, sourceHandle, target, targetHandle } = params;

      const isSourceHandleConnected = edges.some(
        (edge) => edge.source === source && edge.sourceHandle === sourceHandle
      );
      const isTargetHandleConnected = edges.some(
        (edge) => edge.target === target && edge.targetHandle === targetHandle
      );

      // Determine the first node based on the drag-and-drop order rather than position
      const firstNodeId = nodes.length > 0 ? nodes[0].id : null;

      if (target === firstNodeId) {
        toast.error("The first node cannot have input connections.");
        return;
      }

      if (isSourceHandleConnected || isTargetHandleConnected) {
        toast.error("Only one connection is allowed per handle");
        return;
      }

      setEdges((eds) =>
        addEdge(
          {
            ...params,
            type: "smoothstep",
            markerEnd: { type: MarkerType.ArrowClosed },
            label: "",
          },
          eds
        )
      );
    },
    [edges, nodes, setEdges]
  );

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      if (!reactFlowWrapper.current) {
        return;
      }

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const masterId = event.dataTransfer.getData("application/reactflow");

      // Ensure the drop happens within the bounds of the canvas
      if (
        typeof masterId === "undefined" ||
        !masterId ||
        !reactFlowInstance ||
        !master.parameter_types.length
      ) {
        return;
      }

      // const masterId = event.dataTransfer.getData("application/reactflow"); // Retrieve `masterId`
      // const masterDataItem = master.find((m) => m._id === masterId); // Find the correct `masterId`

      // if (!masterDataItem) {
      //   console.warn(`Master item not found for ID: ${masterId}`);
      //   return;
      // }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      const masterDataItem = master.parameter_types
        .flatMap((parameterType) => parameterType.masters)
        .find((m) => m._id === masterId);

      if (!masterDataItem) {
        console.warn(`Master item not found for ID: ${masterId}`);
        return;
      }

      const newNode = {
        id: `${masterId}`, // Use `masterId` as the unique identifier
        type: "defaultNode", // Determine the node type
        position,
        sourcePosition: "right",
        targetPosition: "left",
        data: {
          label: masterDataItem.master_name, // Use correct name
          img: masterDataItem.img, // Include image if present
        },
      };

      setNodes((nds) => nds.concat(newNode));
      setUsedNodes((prev) => [...prev, masterId]); // Add the name to the used list
    },
    [reactFlowInstance, master, nodes, usedNodes] // Dependencies
  );

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNode(null);
    setEditData({});
  };

  const handleEditNodeData = (key, value) => {
    // Update the temporary edit data
    setEditData((prevData) => ({ ...prevData, [key]: value }));
  };

  const saveChanges = () => {
    if (!selectedNode) return;

    setNodes((nds) =>
      nds.map((node) =>
        node.id === selectedNode.id
          ? {
              ...node,
              data: { ...node.data, label: editData.label },
              sourcePosition: editData.sourcePosition,
              targetPosition: editData.targetPosition,
            }
          : node
      )
    );

    closeModal(); // Close modal after saving
  };

  const openEdgeLabelModal = (edgeId) => {
    // Fetch the correct edge from the current state
    const edge = edges.find((e) => e.id === edgeId);
    const currentLabel = edge?.label || ""; // Get existing label or default to empty
    setEdgeLabelModal({ isOpen: true, label: currentLabel, edgeId }); // Open modal with current label
  };

  // Function to handle adding a label to an edge
  const addLabelToEdge = (edgeId, label) => {
    setEdges((eds) =>
      eds.map((edge) =>
        edge.id === edgeId
          ? { ...edge, label } // Update edge with new label
          : edge
      )
    );
    setEdgeLabelModal({ isOpen: false, label: "", edgeId: null }); // Close modal after updating label
  };

  const onEdgeClick = (event, edge) => {
    event.stopPropagation();

    closeContextMenu();
    if (!reactFlowWrapper.current) {
      return;
    }

    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const xPosition = event.clientX - reactFlowBounds.left;
    const yPosition = event.clientY - reactFlowBounds.top;
    setEdgeToDelete({ id: edge.id, position: { x: xPosition, y: yPosition } }); // Capture edge ID and position
  };

  const onDeleteEdge = () => {
    if (edgeToDelete) {
      setEdges((eds) => eds.filter((edge) => edge.id !== edgeToDelete.id)); // Delete the specified edge
      setEdgeToDelete(null); // Reset the edge to delete
    }
  };

  // Event handler for right-click on a node
  const onNodeContextMenu = (event, node) => {
    event.preventDefault(); // Prevent the default context menu

    if (edgeToDelete) {
      setEdgeToDelete(null); // Hide the delete button when clicking outside
    }
    if (!reactFlowWrapper.current) {
      return;
    }

    const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    const yOffset = 150;

    setContextMenu({
      isOpen: true,
      position: {
        x: event.clientX,
        y: event.clientY - reactFlowBounds.top + yOffset,
      },
    });
    setSelectedNode(node);
    setEditData({
      label: node.data.label,
      sourcePosition: node.sourcePosition,
      targetPosition: node.targetPosition,
    });
  };

  const closeContextMenu = () =>
    setContextMenu({ isOpen: false, position: { x: 0, y: 0 } });

  const onDeleteNode = (nodeToDelete) => {
    // Remove the node from the list of nodes
    setNodes((nds) => nds.filter((node) => node.id !== nodeToDelete.id));

    // Remove all edges connected to the node
    setEdges((eds) =>
      eds.filter(
        (edge) =>
          edge.source !== nodeToDelete.id && edge.target !== nodeToDelete.id
      )
    );

    // Remove the deleted node from the list of used nodes
    setUsedNodes((used) => used.filter((nodeId) => nodeId !== nodeToDelete.id));

    closeContextMenu(); // Close the context menu after deletion
  };

  const hideButton = () => {
    if (edgeToDelete) {
      setEdgeToDelete(null); // Hide the delete button when clicking outside
    }
    closeContextMenu();
  };
  const handleSave = async () => {
    setLoading(true);
    try {
      const nodesArray = [];
      const edgesArray = [];

      // Collect nodes in nodesArray
      nodes.forEach((node) => {
        const nodeObject = {
          id: node.id,
          type: node.type,
          style: { ...node.style },
          data: {
            ...node.data, // Includes parameter_type and label
          },
          position: {
            x: node.position.x.toFixed(2), // Fixing to 2 decimal places
            y: node.position.y.toFixed(2), // Fixing to 2 decimal places
          },
          sourcePosition: node.sourcePosition,
          targetPosition: node.targetPosition,
        };
        nodesArray.push(nodeObject);
      });

      // Collect edges in edgesArray
      edges.forEach((edge) => {
        edgesArray.push({
          id: `${edge.source}->${edge.target}`,
          source: edge.source,
          target: edge.target,
          label: edge.label,
          type: edge.type,
          markerEnd: { ...edge.markerEnd },
        });
      });

      // Organize nodes and edges into separate sections in elements
      const elements = [{ nodes: nodesArray }, { edges: edgesArray }];

      const elementsJSON = JSON.stringify(elements, null, 2);

      await new Promise((resolve) => setTimeout(resolve, 0));

      const trimmedTemplateName = templateName.trim();
      const trimmedTemplateCode = templateCode.trim();

      // if (trimmedTemplateName === "") {
      //   setLoading(false);
      //   toast.error("Please enter a template name.");
      //   return;
      // }

      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            template_type_id: `${template_type_id}`,
            template_name: trimmedTemplateName,
            template_code: trimmedTemplateCode,
            structure: elementsJSON,
          }),
        }
      );

      // if (!response.ok) {
      //   throw new Error("Failed to save template");
      // }

      setLoading(false);
      // Ensure that the response is in the expected format before trying to parse it as JSON
      // const responseData = await response.text(); // or response.blob(), response.formData(), etc., depending on the server response type

      navigate(`/template_types/${template_type_id}`);
      setTimeout(() => {
        toast.success("Template saved successfully");
      }, 200);
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      toast.error(error.message);
    }
  };

  /////////////
  useEffect(() => {
    fetchNodes();
  }, []);

  useEffect(() => {
    if (reactFlowInstance) {
      reactFlowInstance.fitView();
    }
  }, [reactFlowInstance]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="tb-responsive templatebuilder-body">
            <div className="tb-container pt-3">
              <nav
                className="breadcrumb-nav show-breadcrumb"
                aria-label="breadcrumb"
              >
                <h5>New {master ? TemplateTypeName : "Loading..."}</h5>
                <ol className="breadcrumb template-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Templates</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/template_types/${template_type_id}`}>
                      {master ? TemplateTypeName : "Loading..."}
                    </Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Create
                  </li>
                </ol>
              </nav>

              <div
                style={{ marginRight: 0, marginLeft: 0 }}
                className="row tb-header align-content-center "
              >
                <div className="col-md-3" style={{ width: "300px" }}>
                  <div className="tb-search-div">
                    <img
                      src={search1}
                      className="tg-search-icon"
                      alt="search icon"
                    />
                    <input
                      className="tb-search-input"
                      placeholder="search"
                      style={{ padding: "8px 35px" }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>

                <div className="col text-center">
                  <div className="d-flex justify-content-between align-content-center">
                    <h6 className="align-content-center mt-2">
                      Template Builder
                    </h6>
                    <div className="d-flex gap-3">
                      <div className="tb-search-div d-flex gap-3">
                        <img
                          src={folder}
                          className="tg-search-icon"
                          alt="folder icon"
                        />
                        <input
                          className="tb-search-input"
                          placeholder="Template Code"
                          style={{ padding: "8px 35px", width: "350px" }}
                          value={templateCode}
                          onChange={(e) => setTemplateCode(e.target.value)}
                          ref={templateCodeRef}
                        />
                      </div>
                      <div className="tb-search-div d-flex gap-3">
                        <img
                          src={folder}
                          className="tg-search-icon"
                          alt="folder icon"
                        />
                        <input
                          className="tb-search-input"
                          placeholder="Template Name"
                          style={{ padding: "8px 35px", width: "350px" }}
                          value={templateName}
                          onChange={(e) => setTemplateName(e.target.value)}
                          ref={templateNameRef}
                        />
                        <button
                          onClick={() => {
                            handleSave();
                          }}
                          className="tb-save-btn"
                        >
                          SAVE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dndflow " onClick={hideButton}>
                <Sidebar
                  master={master}
                  usedNodes={usedNodes}
                  searchQuery={searchQuery}
                />

                <ReactFlowProvider>
                  <div
                    className="reactflow-wrapper"
                    ref={reactFlowWrapper}
                    style={{ height: 600 }}
                  >
                    <ReactFlow
                      nodes={nodes}
                      edges={edges}
                      nodeTypes={nodeTypes} // Register custom node types
                      onNodesChange={onNodesChange}
                      onEdgesChange={onEdgesChange}
                      onConnect={onConnect}
                      onInit={setReactFlowInstance}
                      onDrop={onDrop}
                      onDragOver={onDragOver}
                      onNodeContextMenu={onNodeContextMenu}
                      onEdgeClick={onEdgeClick}
                      fitView
                      defaultViewport={{ x: 0, y: 0, zoom: 2 }}
                    >
                      <Controls />
                      <SmoothStepEdge type="smoothstep" />
                      {/* Display delete button when edgeToDelete is set */}
                      {edgeToDelete && (
                        <div
                          className="edit-cont"
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            left: edgeToDelete.position.x, // Correct position
                            top: edgeToDelete.position.y, // Correct position
                            zIndex: 10,
                          }}
                        >
                          <button
                            className="edit-btn"
                            onClick={() => openEdgeLabelModal(edgeToDelete.id)}
                          >
                            Add Label
                          </button>
                          <button
                            className="delete-btn"
                            onClick={(e) => {
                              e.stopPropagation(); // Ensure only this click is registered
                              onDeleteEdge(); // Trigger edge deletion
                            }}
                          >
                            Delete Edge
                          </button>
                        </div>
                      )}
                      <Background
                        id="1"
                        gap={10}
                        color="#e8e8e8"
                        variant={BackgroundVariant.Lines}
                      />
                    </ReactFlow>
                  </div>
                </ReactFlowProvider>

                {contextMenu.isOpen && (
                  <div
                    className="edit-cont"
                    style={{
                      position: "absolute",
                      top: contextMenu.position.y,
                      left: contextMenu.position.x,
                    }}
                    onClick={closeContextMenu}
                  >
                    <button
                      className="edit-btn"
                      onClick={() => setIsModalOpen(true)}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => onDeleteNode(selectedNode)}
                    >
                      Delete
                    </button>{" "}
                    {/* Use onDeleteNode */}
                  </div>
                )}

                <div
                  id="overlay"
                  className={`modal fade ${isModalOpen ? "show" : ""}`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: isModalOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div className="addunit-card Width 25%">
                      <div className="addunit-header">
                        <h4>Edit Node Data</h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={closeModal}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <form onSubmit={saveChanges}>
                        {selectedNode && ( // Add this condition
                          <div className="addunit-form">
                            <div className="row">
                              <div className="col-sm-6">
                                <div className="d-flex flex-column">
                                  <label
                                    htmlFor="node-name"
                                    className="addunit-form-text"
                                  >
                                    Node Name *
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="node-name"
                                    value={editData.label}
                                    onChange={(e) =>
                                      handleEditNodeData(
                                        "label",
                                        e.target.value
                                      )
                                    }
                                    required
                                  />
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="d-flex flex-column">
                                  <label
                                    htmlFor="parameter-name"
                                    className="addunit-form-text"
                                  >
                                    Parameter Type *
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="parameter-name"
                                    value={editData.parameter_type}
                                    onChange={(e) =>
                                      handleEditNodeData(
                                        "parameter_type",
                                        e.target.value
                                      )
                                    }
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="addunit-card-footer">
                          <button
                            type="button"
                            className="discard-btn"
                            onClick={closeModal}
                          >
                            Close
                          </button>
                          <button type="submit" className="update-btn">
                            Save Changes
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {/* Modal to add label to an edge */}
                <div
                  id="overlay"
                  className={`modal fade ${
                    edgeLabelModal.isOpen ? "show" : ""
                  }`}
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    zIndex: 30,
                    display: edgeLabelModal.isOpen ? "block" : "none",
                    transition: "width 2s",
                  }}
                >
                  <div>
                    <div className="addunit-card Width 25%">
                      <div className="addunit-header">
                        <h4>Add or Edit Edge Label</h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={() =>
                            setEdgeLabelModal({
                              isOpen: false,
                              label: "",
                              edgeId: null,
                            })
                          }
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>

                      <div className="addunit-form">
                        <div className="row">
                          <div className="d-flex flex-column">
                            <label
                              htmlFor="edge-name"
                              className="addunit-form-text"
                            >
                              Edge Label
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="edge-name"
                              value={edgeLabelModal.label}
                              onChange={(e) =>
                                setEdgeLabelModal({
                                  ...edgeLabelModal,
                                  label: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="addunit-card-footer">
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={() =>
                            setEdgeLabelModal({
                              isOpen: false,
                              label: "",
                              edgeId: null,
                            })
                          }
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="update-btn"
                          onClick={() =>
                            addLabelToEdge(
                              edgeLabelModal.edgeId,
                              edgeLabelModal.label
                            )
                          }
                        >
                          Add Label
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer autoClose={4000} position={"top-right"} />
    </>
  );
};

export default DnDFlow;
